// DO NOT EDIT -- generated from fs/services/pinguin/pinguin.proto

import { ConfigID, EmailOption, Facility, Notification, NotificationConfig, Recipient } from './model.proto';
import * as protobuf from '../../../google/protobuf';

/**
 * ////////////////////////
 * Notifier
 * ////////////////////////
 */
export namespace NotifierService {

  export const CreateNotificationConfigEndpoint = "/grpc/pinguin.NotifierService/CreateNotificationConfig";
  /** Creates a new NotificationConfig. Will return an error if one already exists with the same ID. */
  export function CreateNotificationConfig(sender: (req: CreateNotificationConfigRequest, endpoint: string) => Promise<NotificationConfig>, req: CreateNotificationConfigRequest): { promise: () => Promise<NotificationConfig>, endpoint: string } {
    return {
      promise: () => sender(req, CreateNotificationConfigEndpoint),
      endpoint: CreateNotificationConfigEndpoint
    };
  }

  export const UpdateNotificationConfigEndpoint = "/grpc/pinguin.NotifierService/UpdateNotificationConfig";
  /** Modify an existing config */
  export function UpdateNotificationConfig(sender: (req: UpdateNotificationConfigRequest, endpoint: string) => Promise<NotificationConfig>, req: UpdateNotificationConfigRequest): { promise: () => Promise<NotificationConfig>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateNotificationConfigEndpoint),
      endpoint: UpdateNotificationConfigEndpoint
    };
  }

  export const UpdateNotificationConfigsForUserEndpoint = "/grpc/pinguin.NotifierService/UpdateNotificationConfigsForUser";
  /** Update a user's subscription for a set of Notification Configs. */
  export function UpdateNotificationConfigsForUser(sender: (req: UpdateNotificationConfigsForUserRequest, endpoint: string) => Promise<NotificationConfig>, req: UpdateNotificationConfigsForUserRequest): { promise: () => Promise<NotificationConfig>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateNotificationConfigsForUserEndpoint),
      endpoint: UpdateNotificationConfigsForUserEndpoint
    };
  }

  export const GetNotificationConfigEndpoint = "/grpc/pinguin.NotifierService/GetNotificationConfig";
  export function GetNotificationConfig(sender: (req: GetNotificationConfigRequest, endpoint: string) => Promise<NotificationConfig>, req: GetNotificationConfigRequest): { promise: () => Promise<NotificationConfig>, endpoint: string } {
    return {
      promise: () => sender(req, GetNotificationConfigEndpoint),
      endpoint: GetNotificationConfigEndpoint
    };
  }

  export const GetAllNotificationConfigsEndpoint = "/grpc/pinguin.NotifierService/GetAllNotificationConfigs";
  /** Get an optionally filtered list of Configs. */
  export function GetAllNotificationConfigs(sender: (req: GetAllNotificationConfigsRequest, endpoint: string) => Promise<GetAllNotificationConfigsResponse>, req: GetAllNotificationConfigsRequest): { promise: () => Promise<GetAllNotificationConfigsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllNotificationConfigsEndpoint),
      endpoint: GetAllNotificationConfigsEndpoint
    };
  }

  export const SendNotificationEndpoint = "/grpc/pinguin.NotifierService/SendNotification";
  /**
   * Creates a new Notification and sends it to the recipients specified in the Config and any additional recipients.
   * If no recipients are specified in either the Config or Additional Recipients,
   * will still save a record but nothing will be sent.
   */
  export function SendNotification(sender: (req: SendNotificationRequest, endpoint: string) => Promise<SendNotificationResponse>, req: SendNotificationRequest): { promise: () => Promise<SendNotificationResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SendNotificationEndpoint),
      endpoint: SendNotificationEndpoint
    };
  }

  export const GetAllNotificationsEndpoint = "/grpc/pinguin.NotifierService/GetAllNotifications";
  /** Get a list of all notifications for the current user. */
  export function GetAllNotifications(sender: (req: GetAllNotificationsRequest, endpoint: string) => Promise<GetAllNotificationsResponse>, req: GetAllNotificationsRequest): { promise: () => Promise<GetAllNotificationsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllNotificationsEndpoint),
      endpoint: GetAllNotificationsEndpoint
    };
  }

  export const MarkNotificationsReadEndpoint = "/grpc/pinguin.NotifierService/MarkNotificationsRead";
  /** Marks a list of notifications as read for the current user */
  export function MarkNotificationsRead(sender: (req: MarkNotificationsReadRequest, endpoint: string) => Promise<{}>, req: MarkNotificationsReadRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, MarkNotificationsReadEndpoint),
      endpoint: MarkNotificationsReadEndpoint
    };
  }

  export const MarkNotificationReadEndpoint = "/grpc/pinguin.NotifierService/MarkNotificationRead";
  /** Mark a single notification from the current user as (un)read */
  export function MarkNotificationRead(sender: (req: MarkNotificationReadRequest, endpoint: string) => Promise<{}>, req: MarkNotificationReadRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, MarkNotificationReadEndpoint),
      endpoint: MarkNotificationReadEndpoint
    };
  }
}

export interface CreateNotificationConfigRequest {
  orgId: string;
  configId: ConfigID | null;
  recipients: Recipient[];
}

export interface UpdateNotificationConfigRequest {
  orgId: string;
  configId: ConfigID | null;
  /** Add new recipients. If this is a UserRecipient and one already exists with the same email, will overwrite. */
  addRecipients: Recipient[];
  /**
   * For UserRecipient, remove the one that matches the email.
   * For BotRecipient, remove the one that matches both the integration_id and destination_id.
   */
  removeRecipients: Recipient[];
}

export interface UpdateNotificationConfigsForUserRequest {
  orgId: string;
  configIds: ConfigID[];
  /** Must match the logged-in user. */
  userEmail: string;
  /**
   * If true, will add a new UserRecipient for each ConfigID where one does not already exist.
   * If false, will delete any matching UserRecipients for the given ConfigId.
   */
  subscribed: boolean | null;
  /**
   * If subscribed is true, will update the email option for each UserRecipient
   * If false, this value will be ignored.
   */
  email: EmailOption;
}

export interface GetNotificationConfigRequest {
  orgId: string;
  configId: ConfigID | null;
}

export interface GetAllNotificationConfigsRequest {
  /** required */
  orgId: string;
  /** optional, defaults to 20 */
  pageSize: number;
  /** optional, makes subsequent paged requests */
  cursor: string;
  /** Optional field for internal use only. If set by a non-internal user, will fail unless it matches the current user. */
  user: string;
  /** Optionally fetch only this set of ConfigIds. If empty, will return all for the org. */
  configIds: ConfigID[];
}

export interface GetAllNotificationConfigsResponse {
  configs: NotificationConfig[];
  /** List of errors */
  errors: GetAllNotificationConfigsResponse.GetConfigError[];
}

export namespace GetAllNotificationConfigsResponse {
  export enum ErrorType {
    ERROR_UNKNOWN = 0,
    ERROR_NOT_FOUND = 1
  }

  export interface GetConfigError {
    configId: ConfigID | null;
    errorType: GetAllNotificationConfigsResponse.ErrorType;
  }
}

export interface SendNotificationRequest {
  orgId: string;
  /**
   * ConfigID must contain facility.
   * If TriggerID is present, will lookup the associated NotificationConfig and include it's Recipients.
   * If no TriggerID is provided, or no NotificationConfig is found, will still save a Notification
   * and send to any addl_recipients.
   */
  configId: ConfigID | null;
  /**
   * Will prevent this Notification instance from being clustered with previous Notifications (matched by ConfigID)
   * Any later Notifications can still be clustered with this one if they do not set force_new.
   */
  forceNew: boolean;
  /**
   * These Recipients will receive the Notification in addition to any found in the NotificationConfig.
   * They will not be saved for subsequent Notifications.
   */
  addlRecipients: Recipient[];
  /** Matches the filename of the template to be used for generating the message content. */
  templateId: string;
  /** The dynamic data for generating content. Field keys should match dynamic fields in the template. */
  templateData: protobuf.Struct | null;
}

export interface SendNotificationResponse {
  /** The ID of the Notification that was just created and sent. */
  notificationId: string;
}

export interface GetAllNotificationsRequest {
  orgId: string;
  /** Clustering will merge notifications for the same ConfigId into one Notification with a count of occurrences */
  cluster: boolean;
  /** The number of results to return. Defaults to 20. */
  pageSize: number;
  /** Optional cursor for subsequent paged requests. */
  cursor: string;
  /** Optional field for internal use only. If set by a non-internal user, will fail unless it matches the current user. */
  user: string;
  filters: NotificationFilters | null;
}

/** These filters are used both for fetching Notifications and marking them as Read. */
export interface NotificationFilters {
  facilitiesFilter: NotificationFilters.FacilitiesFilter | null;
  /** Can filter to read or unread for the current user. */
  readFilter: NotificationFilters.ReadFilter | null;
}

/** These filters are used both for fetching Notifications and marking them as Read. */
export namespace NotificationFilters {
  export interface FacilitiesFilter {
    facilities: Facility[];
  }

  export interface ReadFilter {
    /** Filter to read if true, unread if false */
    read: boolean;
  }
}

export interface GetAllNotificationsResponse {
  /** The matching notifications, sorted by created date with most recent first. */
  notifications: Notification[];
  /** A cursor if not all results were returned. */
  cursor: string;
  /** The total number of results for this request. */
  resultCount: number;
  /** The total number of unread results for this request. */
  unreadCount: number;
}

export interface MarkNotificationsReadRequest {
  orgId: string;
  /**
   * Filters which facilities notifications should be marked as (un)read.
   * If empty, targets ALL facilities.
   */
  facilities: Facility[];
  /** True to mark as read, false to mark as unread. */
  read: boolean | null;
}

export interface MarkNotificationReadRequest {
  orgId: string;
  /** ID of the notification that should be marked as (un)read. */
  notificationId: string;
  /** True to mark as read, false to mark as unread. */
  read: boolean | null;
}
